var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticClass:"pt-5",attrs:{"xs3":"","offset-xs5":""}},[_c('div',{staticClass:"white elevation-2"},[_c('v-toolbar',{attrs:{"flat":"","dense":"","color":"blue darken-3","dark":""}},[_c('v-toolbar-title',[_vm._v("Main page")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f8fd529","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Content.vue
// module id = null
// module chunks = 